module.exports = __webpack_public_path__ + "img/62.efe5ebe6.jpg";